<template>
  <div class="gs-section">
    <div class="gs-section__toolbar">
      <div class="gs-segmented" role="group" aria-label="Signature type">
        <button
          v-for="group in groups"
          :key="group.value"
          type="button"
          class="gs-segmented__item"
          :class="{ 'is-current': currentGroup === group.value }"
          :aria-pressed="currentGroup === group.value ? 'true' : 'false'"
          :data-group="group.value"
          @click="selectGroup(group.value)"
        >
          {{ group.title }}
        </button>
      </div>
      <p v-if="signatures.length" class="gs-section__count">{{ countLabel }}</p>
    </div>

    <div v-if="signatures.length" class="gs-asset-grid">
      <asset-card
        v-for="signature in signatures"
        :key="`${currentGroup}-${signature.id}`"
        collapsible
        :max-height="200"
        :title="signature.name"
      >
        <template slot="preview">
          <pre class="gs-asset-text">{{ signature.post }}</pre>
        </template>
        <template slot="actions">
          <copy-button
            :text="signature.post"
            label="Copy signature"
            :title="$t('frontend_resources_copy_ad_body')"
          />
        </template>
      </asset-card>
    </div>

    <div v-else class="gs-empty">
      <span class="gs-empty__icon"><gs-icon name="edit" size="22" /></span>
      <p class="gs-empty__title">{{ emptyTitle }}</p>
      <p class="gs-empty__text">
        Sign-off blocks you can paste under your emails and forum posts show up here.
      </p>
    </div>
  </div>
</template>

<script>
import AssetCard from '@/components/promotools/AssetCard.vue';
import CopyButton from '@/components/promotools/CopyButton.vue';

export default {
  components: {
    AssetCard,
    CopyButton,
  },
  props: {
    funnelResource: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentGroup: 'email',
    };
  },
  computed: {
    groups() {
      return [
        { title: this.$t('frontend_resource_email'), value: 'email' },
        { title: this.$t('frontend_resource_forum'), value: 'forum' },
      ];
    },
    signatures() {
      const source = (this.funnelResource && this.funnelResource.signatures) || {};
      return (source[this.currentGroup] || []).filter(signature => signature.enabled);
    },
    countLabel() {
      const count = this.signatures.length;
      return `${count} ${count === 1 ? 'signature' : 'signatures'}`;
    },
    emptyTitle() {
      return this.currentGroup === 'email'
        ? this.$t('frontend_resources_no_email_sinatures')
        : this.$t('frontend_resources_no_forum_signatures');
    },
  },
  methods: {
    selectGroup(value) {
      this.currentGroup = value;
    },
  },
};
</script>
